import {
  faArrowLeft,
  faCheck,
  faUnlockKeyhole,
} from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { useMutation } from "@tanstack/react-query";
import { forgotPassword } from "api/services/auth";
import Alert from "components/Alert";
import Button from "components/Button";
import InputField from "components/FormFields/InputField";
import Link from "components/Link";
import AuthLayout from "layouts/AuthLayout";
import React, { useState } from "react";
import { twMerge } from "tailwind-merge";

export default function ForgotPassword() {
  const [emailSent, setEmailSent] = useState(false);

  const forgotPassMutation = useMutation({
    mutationFn: forgotPassword,
    onSuccess: ({ data }) => {
      if (data?.ok) {
        setEmailSent(true);
      }
    },
    onMutate: () => {
      setEmailSent(false);
    },
  });

  const isValidationError =
    forgotPassMutation.isError &&
    forgotPassMutation.error?.response?.data?.error?.name == "ValidationError";

  return (
    <AuthLayout>
      <div className="p-2 rounded-tr-4xl z-10">
        <div
          className={twMerge(
            "h-[60px] w-[60px] mx-auto my-2 rounded-full transition-all  flex justify-center items-center",
            emailSent ? "bg-green-500 text-slate-100" : "bg-slate-300"
          )}
        >
          {emailSent ? (
            <FontAwesomeIcon className="" icon={faCheck} />
          ) : (
            <FontAwesomeIcon
              className="text-slate-600"
              icon={faUnlockKeyhole}
            />
          )}
        </div>

        <h1 className="text-2xl text-center font-semibold ">
          Şifrənizi unutmusunuz?
        </h1>
        <p className="text-slate-300 text-center">
          Şifrənizi yeniləmək üçün e-mail adresinizi daxil edin.
        </p>
        <form
          className="mt-4"
          onSubmit={(e) => {
            e.preventDefault();
            forgotPassMutation.mutate(
              {
                email: e.target.email.value,
              },
              {
                onSuccess: () => {
                  e.target.email.value = "";
                },
              }
            );
          }}
        >
          <InputField
            required
            name="email"
            placeholder="E-mail addressini daxil edin"
            id="email"
            label="E-mail"
            className="flex-grow"
          />
          {isValidationError ? (
            <div className="mt-2 relative">
              <p className="text-red-500">
                Email ünvanı tapılmadı. Yenidən cəhd edin.
              </p>
            </div>
          ) : (
            forgotPassMutation.isError && (
              <div className="mt-2 relative">
                <p className="text-red-500">
                  {forgotPassMutation.error?.response?.data?.error?.message}
                </p>
              </div>
            )
          )}

          <Button
            isLoading={forgotPassMutation.isLoading}
            className="mt-4 w-full fill-white"
          >
            Parolu yenilə
          </Button>
          {emailSent && (
            <Alert type="success">
              Parolu yeniləmə linki e-poçt ünvanınıza göndərildi.{" "}
              <small>
                <i>(Spam qovluğunu da yoxlayın.)</i>
              </small>
            </Alert>
          )}
        </form>
      </div>
    </AuthLayout>
  );
}
